import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Landmark, Scale } from "lucide-react";

const links = [
  {
    label: "Bombay High Court",
    href: "https://bombayhighcourt.gov.in/bhc/",
    desc: "Official cause lists, orders and information from the Bombay High Court.",
    Icon: Landmark,
  },
  {
    label: "Recent Supreme Court Judgements",
    href: "https://www.sci.gov.in/latest-orders/",
    desc: "Latest orders and judgements published by the Supreme Court of India.",
    Icon: Scale,
  },
];

export default function LegalInsights() {
  return (
    <section id="insights" className="py-24 md:py-40 bg-[#0B0B0B] border-t border-white/5" data-testid="insights-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-24">
        <div className="mb-16 md:mb-20">
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-white/95">Legal<br/><span className="italic text-[#C8A45D]/90">insights.</span></h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
          {links.map((l, i) => {
            const Icon = l.Icon;
            return (
              <motion.a
                key={l.label}
                href={l.href}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="group bg-[#0B0B0B] p-10 md:p-14 flex flex-col justify-between min-h-[280px] transition-colors duration-500 hover:bg-white/[0.02]"
                data-testid={`insight-link-${i}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon className="text-[#C8A45D]" strokeWidth={1.1} size={32} />
                  <ArrowUpRight
                    className="text-white/40 group-hover:text-[#C8A45D] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500"
                    strokeWidth={1.2}
                    size={22}
                  />
                </div>
                <div>
                  <div className="font-cinzel text-[10px] tracking-[0.3em] text-[#C8A45D] mb-3">0{i + 1} · OFFICIAL LINK</div>
                  <h3 className="font-serif-display text-3xl md:text-4xl text-white/95 leading-tight mb-4 group-hover:text-[#C8A45D] transition-colors duration-500">
                    {l.label}
                  </h3>
                  <p className="text-white/55 font-body text-sm leading-relaxed max-w-md">{l.desc}</p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
